/**
 * Enum representing constraint operators for numeric range evaluation
 */
export enum NumericRangeConstraintOperator {
    Between = 'Between',
    GreaterThan = 'GreaterThan',
    LessThan = 'LessThan',
}

/**
 * Base interface for numeric range constraints
 * Used for polymorphic constraint types with discriminated union
 */
export interface NumericRangeConstraintBase {
    $type: NumericRangeConstraintOperator;
}

/**
 * Between constraint - value must be within range [min, max]
 * - Inclusive lower bound (>=)
 * - Inclusive upper bound (<=)
 */
export interface BetweenConstraint extends NumericRangeConstraintBase {
    $type: NumericRangeConstraintOperator.Between;
    minValue: number;
    maxValue: number;
}

/**
 * Greater than constraint - value must be strictly greater than threshold
 */
export interface GreaterThanConstraint extends NumericRangeConstraintBase {
    $type: NumericRangeConstraintOperator.GreaterThan;
    value: number;
}

/**
 * Less than constraint - value must be strictly less than threshold
 */
export interface LessThanConstraint extends NumericRangeConstraintBase {
    $type: NumericRangeConstraintOperator.LessThan;
    value: number;
}

/**
 * Union type for all constraint types
 */
export type NumericRangeConstraint = BetweenConstraint | GreaterThanConstraint | LessThanConstraint;

/**
 * Container for pass/warning/fail constraints
 * Supports multiple constraints per result type
 * Priority: Pass > Warning > Fail
 */
export interface NumericRangeConstraints {
    schemaVersion?: string;
    pass?: NumericRangeConstraint[];
    warning?: NumericRangeConstraint[];
    fail?: NumericRangeConstraint[];
}
